<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="排队池名称">
          <el-input placeholder="请输入排队池名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
      <el-form-item label="请选择产品">
        <el-select v-model="formInline.product_id" filterable placeholder="请选择产品">
          <el-option v-for="item in product" :key="item.product_id" :label="item.product_name" :value="item.product_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item >
        <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
      </el-form-item>

      </el-form>
    </div>



    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="scope.$index" label="序号">
              <template slot-scope="scope">
                {{ scope.row.ind }}
              </template>
            </el-table-column>

            <el-table-column prop="order.order_no" label="订单号"></el-table-column>

            <el-table-column prop="product.product_name" label="产品名称"></el-table-column>
            <el-table-column prop="user.nickName" label="购买人"></el-table-column>

            <el-table-column prop="is_award" label="是否有奖励" >
              <template slot-scope="scope">
                <div v-if="scope.row.is_award == 0">无奖励</div>
                <div v-if="scope.row.is_award == 1">有奖励</div>
              </template>

            </el-table-column>


            <el-table-column prop="is_settled" label="是否结算" >
              <template slot-scope="scope">
                <div v-if="scope.row.is_settled == 0">未结算</div>
                <div v-if="scope.row.is_settled == 1">已结算</div>
              </template>

            </el-table-column>

            <el-table-column prop="order.receipt_status.text" label="是否收货" >
            </el-table-column>


            <el-table-column prop="order.order_status.text" label="订单状态"></el-table-column>



            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="detailClick(scope.row)" type="text" size="small">详情</el-button>  
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :lineup_id="lineup_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import LineupApi from '@/api/lineup.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          product_id:0,
        },

        open_add:false,
        open_edit:false,
        lineup_id:"",
        dialogVisible:false,
        product:[]
      };
    },
    created() {

      /*获取列表*/
      this.getProducts();
      this.getTableList();
     
    },
    methods: {
      getProducts(){
        let self = this;
        let Params = this.formInline;
        self.loading = true;
        LineupApi.getProducts(Params, true)
          .then(data => {
            self.loading = false;
            self.product = data.data;
            console.log('self.product[0].product_id',self.product[0].product_id)
            self.formInline.product_id =  parseInt(self.product[0].product_id)
            self.getTableList();
          })
          .catch(error => {
          });
      },
      detailClick(row){

      let self = this;
      let params = row.order_id;
      self.$router.push({
        path: '/order/order/Detail',
        query: {
          order_id: params
        }
      });
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//排队池标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        LineupApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.lineup_id = row.lineup_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            LineupApi.del(
              {
                lineup_id: row.lineup_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/lineup/index/index.vue